import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AccessToken, DownloadJob } from 'common-models';
import { Configuration } from 'src/Configuration';

export const adminDownloadJobsApiSlice = createApi({
  reducerPath: 'adminDownloadJobsApi',
  tagTypes: ['downloadJobs'],
  baseQuery: fetchBaseQuery({
    baseUrl: Configuration.ApiUrl,
    prepareHeaders(headers) {
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // Get all download jobs
    getAllDownloadJobs: builder.query<DownloadJob[], AccessToken>({
      query: (accessToken) => ({
        url: '/admin/download-jobs',
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }),
      providesTags: [{ type: 'downloadJobs', id: 'all' }],
    }),
    // Delete a download job
    deleteDownloadJob: builder.mutation<void, { jobId: string; accessToken: string }>({
      query: ({ jobId, accessToken }) => ({
        url: `/admin/download-jobs/${jobId}`,
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }),
      invalidatesTags: [{ type: 'downloadJobs', id: 'all' }],
    }),
  }),
});

export const { useGetAllDownloadJobsQuery, useDeleteDownloadJobMutation } = adminDownloadJobsApiSlice;
